import React, { useEffect, useState } from "react"
import { PrimaryText, SecondaryText } from "../../ui/Text"
import { BLACK, PRIMARY } from "../../ui/Colors"
import { Grid } from "@mui/material"
import { supabase } from '../../../supabaseClient'
import placeholder_image_article from "../../../assets/placeholder_image_article.png"

export const getImage = async (imageName: string): Promise<string | null> => {
    const { data, error } = await supabase
        .storage
        .from(process.env.REACT_APP_SUPABASE_BUCKET_FAQ_PICTURES)
        .createSignedUrl(imageName, 60 * 60) // Lien valide 1h

    if (error) {
        console.error(`Erreur lors de la récupération de l'URL signée pour ${imageName}:`, error.message)
        return null
    }

    return data?.signedUrl ?? null
}

export const SupportArticles = ({ title, description, link, imageName }: { title: string, description: string, link: string, imageName: string }) => {
    const [imageToDisplay, setImageToDisplay] = useState<string | null>(null)
    const handleSupport = () => {
        window.open(
            link,
            '_blank'
        )
    }
    useEffect(() => {
        const fetchImage = async () => {
            const signedUrl = await getImage(imageName)
            setImageToDisplay(signedUrl)
        }

        fetchImage()
    }, [])
    return (
        <Grid container border={1} borderColor={PRIMARY} borderRadius={2} p="1vw" mb="1vh" width={"100%"} onClick={handleSupport} alignItems="center" sx={{
            cursor: 'pointer !important', "& .MuiTypography-root": {
                cursor: 'pointer !important'
            }
        }}>
            <Grid width="25%" justifyContent="center" container>
                {imageToDisplay ? <img src={imageToDisplay} alt={imageName} style={{ maxWidth: '8vw' }} /> : <img src={placeholder_image_article} alt={placeholder_image_article} style={{ maxWidth: '8vw' }} />}
            </Grid>
            <Grid ml="2vw" width={"64%"}>
                <PrimaryText color={BLACK} bold>{title}</PrimaryText>
                <SecondaryText>{description}</SecondaryText>
            </Grid>
        </Grid >
    )
}
